import { Injectable } from '@angular/core';

@Injectable()
export class SupportService {
  link = 'https://support.twdc.technology/product/mediamonorail';

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/support.service.ts